import ImageOptimizer from '@/components/image-optimizer';
import { cn } from '@/lib/utils';
import ReviewArrow from '@/svg/review_arrow.svg';
import { BranchType } from '@/types/branch.type';
import BranchReviewList from './branch-review-list';
/**
 * BranchReviewSection 컴포넌트
 * 작성자: AI Assistant
 * 설명: 별점과 실제 이용자 리뷰 슬라이더를 렌더링합니다.
 * props:
 *   - rating: 평균 별점
 *   - reviews: 리뷰 배열
 */

interface BranchReviewSectionProps {
  rating: number;
  reviews: BranchType['reviews'];
  className?: string;
  onMoreReviewClick: () => void;
}

export default function BranchReviewSection({
  reviews,
  className,
  onMoreReviewClick,
}: BranchReviewSectionProps) {
  const hasReviews = reviews && reviews.length > 0;
  return (
    <section className={cn('w-full', className)}>
      <div className="mb-5 flex items-center justify-between">
        <h2 className="typo-22 desktop:typo-24 text-level-2 font-extrabold">
          실제 이용자 리뷰
        </h2>
        {hasReviews ? (
          <div className="flex items-center gap-1">
            <button
              className="text-level-4 typo-16 cursor-pointer font-bold"
              onClick={onMoreReviewClick}
            >
              더 많은 리뷰 보기
            </button>
            <ReviewArrow />
          </div>
        ) : (
          <></>
        )}
      </div>
      {!hasReviews ? (
        <div className="bg-bg-graylight flex flex-col items-center justify-center rounded-xl py-7">
          <div className="mb-2">
            <ImageOptimizer
              src="/images/icons/icon_review.svg"
              alt="리뷰 없음"
              width={32}
              height={32}
            />
          </div>
          <p className="typo-16 text-level-3 text-center">
            등록된 리뷰가 없습니다. 첫 리뷰를 작성해주세요.
          </p>
        </div>
      ) : (
        <BranchReviewList review={reviews} />
      )}
    </section>
  );
}
